<template>
  <header class="header preloader-container">
    <!--    <div-->
    <!--      v-show="!headerLoading"-->
    <!--      class="preloader"-->
    <!--      style="background-color: rgba(0,0,0,0.4)"-->
    <!--    >-->
    <!--      <spinner :animation-duration="1000" :size="60" :color="'#2E79EF'" />-->
    <!--    </div>-->
    <!--    {{ headerLoading }}-->
    <!--    <hr />-->
    <!--    {{ Object.keys(money_by_currency).length || false }}-->
    <!--    {{ portfolioMoneyByCurrency(currency_selected) || false }}-->
    <!--    {{ incomeSinceYearBeginning || false }}-->
    <div class="row heading">
      <h1 class="title">{{ $t("broker account") }}</h1>
      <currency-picker
        class="heading__currency-picker"
        @select-currency="onCurrencyChange"
      />
    </div>
    <div class="row data">
      <div class="data__item row align-center">
        <div>
          <h3 class="data__title">{{ $t("current balance") }}</h3>
          <p class="data__currency currency">
            {{
              !portfolio_loading
                ? `${$formatMoney(
                    portfolioMoneyByCurrency(currency_selected),
                    0
                  )} ${currency_sign}`
                : "Загрузка..."
            }}
          </p>

          <p class="data__subcurrency">
            <span v-for="(value, key, index) in portfolio_all_sum_list">
              <span v-if="key != currency_selected">
                {{ currency_sign_by_ticker(key) }}
                {{ $formatMoney(portfolioMoneyByCurrency(key), 0) }}
                <span
                  v-if="
                    index < Object.entries(portfolio_all_sum_list).length - 1
                  "
                  >∙</span
                >
              </span>
            </span>
            <!--            {{ balanceByCurrency("USD") }} $ ∙ {{ balanceByCurrency("RUB") }} ₽-->
            <!--            ∙ {{ balanceByCurrency("EUR") }} €-->
          </p>
          <p class="small-title">
            Индикативная стоимость на дату закрытия торгов
          </p>
        </div>

        <!--        <router-link to="/pay" class="data__button button hide-mobile">{{-->
        <!--          $t("replenish")-->
        <!--        }}</router-link>-->
      </div>
      <div class="data__item hide-tablet hide-mobile">
        <h3 class="data__title">{{ $t("blocked amount") }}</h3>
        <p class="data__currency currency red">
          {{
            checkLoading(money_by_currency["moneyBlocked"])
              ? `${$formatMoney(
                  money_by_currency["moneyBlocked"]
                )} ${sign_by_currency}`
              : "Загрузка..."
          }}
        </p>
      </div>
      <div class="data__item hide-tablet hide-mobile">
        <h3 class="data__title">{{ $t("available funds") }}</h3>
        <p class="data__currency currency green">
          {{
            checkLoading(money_by_currency["moneyFree"])
              ? `${$formatMoney(
                  money_by_currency["moneyFree"]
                )} ${sign_by_currency}`
              : "Загрузка..."
          }}
        </p>
      </div>
      <div class="data__item hide-tablet hide-mobile">
        <h3 class="data__title">{{ $t("incomeSinceYearBeginning") }}</h3>
        <p
          v-if="incomeSinceYearBeginning !== undefined"
          class="data__currency currency green"
        >
          {{
            checkLoading(incomeSinceYearBeginning)
              ? `${incomeSinceYearBeginning}`
              : "Загрузка..."
          }}
        </p>
        <p
          v-else
          class="data__currency income__income-since-year-beginning-error red"
        >
          {{ `${incomeSinceYearBeginningError}` }}
        </p>
      </div>
    </div>
    <div class="action row align-center">
      <!--      <router-link-->
      <!--        to="/instruction"-->
      <!--        class="action__button action__item button filled hide-tablet hide-mobile"-->
      <!--      >-->
      <!--        {{ $t("buy security") }}-->
      <!--      </router-link>-->
      <router-link
        to="/stock"
        class="action__link action__item hide-tablet hide-mobile"
        >{{ $t("favorites") }}</router-link
      >
      <watch-list class="action__item action__watch-list" />
    </div>
  </header>
</template>

<script>
import { mapGetters } from "vuex";
import CurrencyPicker from "@/components/common/CurrencyPicker";
import WatchList from "./WatchList";
import { HalfCircleSpinner } from "epic-spinners";

export default {
  components: {
    spinner: HalfCircleSpinner,
    "currency-picker": CurrencyPicker,
    "watch-list": WatchList
  },
  watch: {
    portfolio() {
      this.fetchData();
    }
  },
  computed: {
    ...mapGetters([
      "currencySign",
      "currentBalance",
      "freeAmount",
      "blockedAmount",
      "balanceByCurrency",
      "isUserBalanceLoading",
      "incomeSinceYearBeginning",
      "incomeSinceYearBeginningError",
      "totalMoneyInSelectedCurrency"
    ]),
    ...mapGetters({
      money_by_currency: "getMoneyDataByCurrency",
      sign_by_currency: "getSelectedCurrencySign",
      portfolio_all_sum_list: "getPortfolioSum",
      portfolio_selected: "getPortfolioSumByCurrency",
      currency_selected: "getSelectedCurrency",
      currency_sign: "getSelectedCurrencySign",
      currency_sign_by_ticker: "getCurrencySignByTicker",
      portfolio: "selectedPortfolio",
      portfolio_loading: "getPortfolioLoading"
    }),
    headerLoading() {
      let money_by_currency =
        Object.keys(this.money_by_currency).length || false;
      let portfolio =
        this.portfolioMoneyByCurrency(this.currency_selected) || false;
      let by_year = this.incomeSinceYearBeginning || false;
      return money_by_currency && portfolio && by_year;
      // if (money_by_currency )
    }
  },
  methods: {
    portfolioMoneyByCurrency(currency) {
      let sum = 0;
      let money_sum = this.$store.getters.getMoneyDataByCurrencyGiven(currency);
      let portfolio_money = this.$store.getters.getPortfolioSumByCurrencyGiven(
        currency
      );
      let sum_stack = {
        portfolio: parseFloat(portfolio_money || 0),
        money_free: parseFloat(money_sum["moneyFree"] || 0),
        money_block: parseFloat(money_sum["moneyBlocked"] || 0),
        money_repo: parseFloat(money_sum["moneyRepo"] || 0),
        money_depo: parseFloat(money_sum["moneyDepositSum"] || 0)
      };
      Object.entries(sum_stack).forEach(item => {
        sum += item[1];
      });
      return parseFloat(sum) || null;
    },
    onCurrencyChange(selectedCurrency) {
      this.$store.dispatch("changeCurrency", selectedCurrency);
    },
    checkLoading(value) {
      let test = parseInt(value);
      return Number.isInteger(test) ? true : false;
    },
    fetchData() {
      this.$store.dispatch("fetchFinancialDetails");
      this.$store.dispatch("fetchUserPortfolioData").then(data => {
        let { negativeAmountSecurities } = data;
        // console.log(negativeAmountSecurities);
        negativeAmountSecurities.forEach(each => {
          this.$toasted.error(
            "Отрицательная стоимость " +
              each.ISIN +
              ": " +
              each.AMOUNT +
              " " +
              each.CURRENCY
          );
        });
      });
    }
  },
  mounted() {
    this.fetchData();
    this.$store.dispatch("fetchIncomeSinceYearBeginning");
  }
};
</script>

<style scoped>
.small-title {
  color: white;
  font-size: 12px;
  opacity: 0.7;
  font-weight: 100;
}
.header {
  min-height: 424px;
  width: 100%;
  padding: 40px 0 50px 32px;
  background-color: #222c44;
  box-sizing: border-box;
}

.title {
  margin-right: 30px;
  font-size: 36px;
  font-weight: normal;
  color: #ffffff;
}

.heading {
  display: flex;
  align-items: center;
}

@media (max-width: 1100px) {
  .heading {
    flex-direction: column;
    align-items: flex-start;
  }

  .heading__currency-picker {
    margin-top: 15px;
  }
}

.income__income-since-year-beginning-error {
  font-size: 15px;
}

.currency {
  font-size: 36px;
  font-weight: normal;
  color: #ffffff;
}

.green {
  color: #5ac480;
}

.red {
  color: #dc3545;
}

.data {
  margin-top: 40px;
}

.data__item:not(:first-child) {
  margin-left: 50px;
}

.data__title {
  font-size: 17px;
  font-weight: normal;
  color: #acb5c5;
}

.data__currency {
  margin: 5px 0 0;
  white-space: nowrap;
}

.data__subcurrency {
  margin-top: 5px;
  font-size: 15px;
  color: #acb5c5;
}

.data__button {
  width: 121px;
  height: 39px;
  margin-left: 25px;
  font-size: 15px;
}

.action {
  margin-top: 80px;
}

.action__item:not(:first-child) {
  margin-left: 50px;
}

.action__button {
  min-width: 90px;
  padding: 20px 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 17px;
}

.action__link {
  width: 107px;
  font-size: 17px;
  color: #acb5c5;
  text-decoration: none;
}

.action__watch-list {
  width: 1000px;
}

@media (max-width: 1100px) {
  .action__item:not(:first-child) {
    margin: 0;
  }
  .currency {
    font-size: 18px;
  }
  .data__title {
    font-size: 12px;
  }
}

@media (max-width: 1400px) {
  .action__watch-list {
    width: 700px;
  }
  .currency {
    font-size: 18px;
  }
  .data__title {
    font-size: 12px;
  }
}

@media (max-width: 800px) {
  .action__watch-list {
    width: 500px;
  }
}

@media (max-width: 500px) {
  .action__watch-list {
    width: 360px;
  }
}

@media (max-width: 400px) {
  .action__watch-list {
    width: 320px;
  }
}

@media all and (max-width: 1200px) {
  .title {
    font-size: 26px;
  }
  .currency {
    font-size: 18px;
  }
  .data__title {
    font-size: 12px;
  }

  .data__subcurrency {
    font-size: 13px;
  }
}
</style>
